import { Card, Col, Image, Radio, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';
import './index.style.less';
import { useAuthUser } from '../../../../@crema/utility/AuthHooks';

export const RoleCard = ({
  setSelectedItem,
  selectedItem,
  description,
  title,
  image,
  value,
}) => {
  return (
    <Card
      onClick={setSelectedItem}
      className={`mentee-card mentee-card__${value} ${
        selectedItem?.includes?.(value)
          ? `mentee-card-selected mentee-card-selected__${selectedItem}`
          : ''
      }`}>
      {image && <Image preview={false} src={image} />}
      <Title className='mentee-card__title' level={4}>
        {title}
      </Title>
      <Text className='mentee-card__des'>{description}</Text>
    </Card>
  );
};

const SelectProfile = ({ defaultValue, onChange }) => {
  const [selectedItem, setSelectedItem] = useState('');
  const { isAuthenticated } = useAuthUser();

  useEffect(() => {
    onChange?.(selectedItem);
  }, [selectedItem]);

  useEffect(() => {
    if (defaultValue) {
      setSelectedItem(defaultValue);
      onChange?.(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className='user-profile-container'>
      <Row gutter={32}>
        <Col md={isAuthenticated ? 2 : 6} xs={24} />
        <Col md={isAuthenticated ? 20 : 12} xs={24}>
          <Row gutter={12}>
            <Col md={12} xs={24}>
              <RoleCard
                title={'MENTOR'}
                description={
                  'To guide a mentee by sharing your expertise in career and personal growth.'
                }
                setSelectedItem={() => setSelectedItem('mentor')}
                selectedItem={selectedItem}
                value={'mentor'}
              />
            </Col>
            <Col md={12} xs={24}>
              <RoleCard
                title={'MENTEE'}
                description={
                  'To connect with mentors who can help you through your needs and situations.'
                }
                setSelectedItem={() => setSelectedItem('mentee')}
                selectedItem={selectedItem}
                value={'mentee'}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default SelectProfile;
